export default {
  'driver-out': 'Motorista a caminho',
  'data-unavailable': 'Dados indisponíveis',
  delivered: 'Entregue',
  'wrong-address': 'Endereço incorreto',
  'not-present': 'Ausente',
  'order-canceled': 'Pedido cancelado',
  'delivery-attempted': 'Tentativa de entrega',
  rescheduled: 'Reagendado',
  'date-unavailable': 'Data indisponível',
}
